module.exports = __webpack_public_path__ + "media/images/facebook_blue_logo_with_white_label-f38f6ea2bd6bc72f104a2e6a0227b82d.svg";